import "./style.scss";
import "./common.js";
import "./detail.js";